import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/** 报价日期提交格式，精确到分钟并带上本地时区偏移，例如 2026-10-26T16:03:00+09:00 */
export const formatQuoteTimeWithZone = (value: Dayjs | string | Date) =>
  dayjs(value).second(0).millisecond(0).format('YYYY-MM-DDTHH:mm:ssZ');
